export function calculePourcentageGain(
  oldPrice: number,
  newPrice: number,
): string {
  const pourcentage = (newPrice / oldPrice - 1) * -100;

  return pourcentage.toFixed(2);
}
